var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(-460 -268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "corporate_14644381_1_",
    "data-name": "corporate_14644381 (1)",
    d: "M8.722,7.476V3.115A1.871,1.871,0,0,0,6.853,1.246H3.115A1.871,1.871,0,0,0,1.246,3.115v8.722a1.871,1.871,0,0,0,1.869,1.869H6.853a.623.623,0,1,1,0,1.246H3.115A3.119,3.119,0,0,1,0,11.838V3.115A3.119,3.119,0,0,1,3.115,0H6.853A3.119,3.119,0,0,1,9.968,3.115V7.476a.623.623,0,1,1-1.246,0ZM3.738,8.1H3.115a.623.623,0,1,0,0,1.246h.623a.623.623,0,1,0,0-1.246Zm3.115,0H6.23a.623.623,0,1,0,0,1.246h.623a.623.623,0,1,0,0-1.246ZM3.738,10.591H3.115a.623.623,0,1,0,0,1.246h.623a.623.623,0,1,0,0-1.246Zm3.115,0H6.23a.623.623,0,1,0,0,1.246h.623a.623.623,0,1,0,0-1.246ZM3.738,3.115H3.115a.623.623,0,0,0,0,1.246h.623a.623.623,0,0,0,0-1.246Zm3.115,0H6.23a.623.623,0,0,0,0,1.246h.623a.623.623,0,1,0,0-1.246ZM3.738,5.607H3.115a.623.623,0,0,0,0,1.246h.623a.623.623,0,0,0,0-1.246Zm3.115,0H6.23a.623.623,0,1,0,0,1.246h.623a.623.623,0,1,0,0-1.246Zm8.08,8.567a3.219,3.219,0,0,0-6.192,0,.623.623,0,0,0,1.207.31,1.973,1.973,0,0,1,3.777,0,.623.623,0,0,0,.6.468.635.635,0,0,0,.156-.019A.624.624,0,0,0,14.933,14.175Zm-3.1-2.96A1.558,1.558,0,1,0,10.28,9.657,1.559,1.559,0,0,0,11.838,11.214Z",
    transform: "translate(463 271)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 20,
    height: 20,
    transform: "translate(460 268)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyName);
export default __webpack_public_path__ + "static/media/companyName.ee4a28077f8944c5de244a0d353125b6.svg";
export { ForwardRef as ReactComponent };